import { useQuery } from "@tanstack/react-query";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import ApiService from "../../services/ApiService";

/**
 * Engagement Value donut on DashboardSponsor for tenants with tracked-accounts, in the
 * same shape as usePAEngagementValue. Follows the partner tab; Earned appears on
 * Portfolio only. Pass enabled=false for tenants without the feature: the endpoint
 * is gated and returns 403.
 */
const useSponsorEngagementValue = ({ sponsorObjectId = 0, enabled = true } = {}) => {
  const tenant = useSelector((state) => state.auth.tenant);
  const date = useSelector((state) => state.date);
  const { startDate, endDate } = date;
  const hasDates = !!(startDate && endDate);

  let since;
  let until;
  if (hasDates) {
    since = format(new Date(startDate), "yyyy-MM-dd");
    until = format(new Date(endDate), "yyyy-MM-dd");
  }

  return useQuery({
    queryKey: ["SPONSOR_ENGAGEMENT_VALUE", tenant.id, sponsorObjectId, startDate, endDate],
    queryFn: () => ApiService.getSponsorEngagementValue(sponsorObjectId, since, until),
    select: (res) => res.data,
    enabled: hasDates && enabled,
    placeholderData: { data: { total: 0, trend: 0, series: [] } },
  });
};

export default useSponsorEngagementValue;
